
import './App.css';
import React, { Component, Fragment, useEffect, useState} from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import axios from 'axios';




import Tasks from './components/tasks';
import TasksMap from './components/tasks_map';
import TasksNoLoc from './components/tasks_no_loc';
import ActivateLoc from './components/activate_loc';
import AnswerSurvey from './components/answer_svy';
import NavBarBrand from './components/navbarbrand';
import NavBarMenu from './components/navbarmenu';
import Login from './components/auth/login';
import Signup from './components/auth/signup';
import Logout from './components/auth/logout';
import NewsFeed from './components/newsfeed';
import Transactions from './components/transactions';
import Friends from './components/friends';
import Init from './components/Init';
import CollaboratorSettings from './components/CollaboratorSettings';



import IMGARROWDOWN from "./components/circle_green_arrow-down.png"
import IMGARROWUP from "./components/circle_green_arrow-up.png"
import IMGARROWRIGHT from "./components/circle_green_arrow-right.png"
import IMGARROWLEFT from "./components/circle_green_arrow-left.png"
import IMGARROWDOWNRIGHT from "./components/circle_green_arrow-downright.png"
import IMGARROWDOWNLEFT from "./components/circle_green_arrow-downleft.png"
import IMGARROWUPRIGHT from "./components/circle_green_arrow-upright.png"
import IMGARROWUPLEFT from "./components/circle_green_arrow-upleft.png"


//Login y Logout
export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const LOGOUT = "LOGOUT";


// paginas derl app de colaborador
export const HOME = "HOME";
export const SURVEYS_BY_LOC = "SURVEYS_BY_LOC";
export const SURVEYS_BY_MAP = "SURVEYS_BY_MAP";
export const SURVEYS_NO_LOC = "SURVEYS_NO_LOC"
export const FRIENDS = "FRIENDS";
export const WALLET = "WALLET";
export const ACTIVATE_LOC = "ACTIVATE_LOC";
export const ANSWER_SVY = "ANSWER_SVY";
export const FEED = "FEED";
export const SETTINGS = "SETTINGS";
export const WITHIN_RAD = 30;  // Activated with in Radiosus (meters)


//Paginas del Website del cliente
export const CLIENT_SURVEYS = "CLIENT_SURVEYS";
export const CLIENT_SURVEY_RESULTS = "SURVEY_RESULTS";
export const CLIENT__NEW_SURVEY = "CLIENT_NEW_SURVEY";
export const CLIENT_CXC = "CLIENT_CXC"



export const MSG_OK = "text-success border border-success"
export const MSG_WARN = "text-warning border border-warning"
export const MSG_ERR = "text-danger border border-danger"



const haversine = require('haversine')





axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'
// Root-relative API so requests from /app/ hit /api/... not /app/api/...
if (typeof window !== 'undefined') {
  axios.defaults.baseURL = window.location.origin
}

// Returns standard auth headers for API calls that require authentication.
const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  'X-CSRFToken': localStorage.getItem('csrftoken'),
  Authorization: `Token ${localStorage.getItem('token')}`
})




function deviceOrientationPermissionRequest() {
  // feature detect
  if (typeof DeviceOrientationEvent.requestPermission === 'function') {
    DeviceOrientationEvent.requestPermission()
      .then(permissionState => {
        if (permissionState === 'granted') {
           return true
        }
          else return false
      
      })
        .catch(console.error);
      
  }
  
}


class App extends Component {


  state = {
    active_page: HOME,
    lastTasksView: SURVEYS_BY_LOC, // list | map | no-loc; used when clicking Tasks in nav
    tasks_by_loc: [],
    selected_loc: -1,
    svy_questions: [],
    active_question: -1,
    loc_is_activated: false,
    active_survey: -1,
    isLoaded: false,
    myLoc: { lat: null, lon: null },
    mapCenter: { lat: null, lon: null },
    msg: { text: 'Welcome', type: MSG_OK },
    heading: 0,

    

  }



  deviceOrientationListener = (event) => {
    //  console.log("alpha:" + (event.webkitCompassHeading !== null?  event.webkitCompassHeading: event.alpha))
      this.setState({heading: event.webkitCompassHeading !== null?  event.webkitCompassHeading: event.alpha});
  }

  GetHeadingpoint = () => {

      if (typeof DeviceOrientationEvent.requestPermission === 'function') {
          DeviceOrientationEvent.requestPermission()
            .then(permissionState => {
              if (permissionState === 'granted') {
                  window.addEventListener('deviceorientation', this.deviceOrientationListener, true);
                  return this.state.heading 
              }
                else return 1
            
            })
              .catch(console.error);
            
        }

  }



  getLocation = () => {
    if (this.watchLocId != null) {
      navigator.geolocation.clearWatch(this.watchLocId);
      this.watchLocId = null;
    }

    let geoOptions = {
      enableHighAccuracy: true,
      timeOut: 20000,
      maximumAge: 5 * 60 * 1000,  // 5 minutes max cached age
    }

    this.displayMsg("", MSG_OK)

    navigator.geolocation.getCurrentPosition(this.geoSuccess, this.geoFailure, geoOptions)

    this.watchLocId = navigator.geolocation.watchPosition(
      (position) => {
        const newLat = position.coords.latitude;
        const newLon = position.coords.longitude;
        const { myLoc } = this.state;
        // Only update state if moved more than 5 meters (web API has no distanceFilter)
        if (myLoc.lat !== null) {
          const moved = haversine(
            { latitude: myLoc.lat, longitude: myLoc.lon },
            { latitude: newLat, longitude: newLon },
            { unit: 'meter' }
          );
          if (moved < 5) return;
        }
        this.setState({ myLoc: { lat: newLat, lon: newLon } });
      },
      this.geoFailure,
      geoOptions
    )
  }

  toRadians = (degrees) =>{return (degrees * Math.PI) / 180;}
  toDegrees = (radians) => { return (radians * 180) / Math.PI; }
  
  getBearing = (startLat, startLng, destLat, destLng) =>{
    const startLatRad = this.toRadians(startLat);
    const startLngRad = this.toRadians(startLng);
    const destLatRad = this.toRadians(destLat);
    const destLngRad = this.toRadians(destLng);
  
    const deltaLng = destLngRad - startLngRad;
  
    const y = Math.sin(deltaLng) * Math.cos(destLatRad);
    const x =
      Math.cos(startLatRad) * Math.sin(destLatRad) -
      Math.sin(startLatRad) * Math.cos(destLatRad) * Math.cos(deltaLng);
    const bearingRad = Math.atan2(y, x);
    const bearingDeg = this.toDegrees(bearingRad);

    //console.log("getBearing: ")
    //console.log(bearingDeg + 360)
  
    return (bearingDeg + 360) % 360;
  }

  getCardinalDirection(bearing) {
    const directions = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
    const index = Math.round(bearing / 45) % 8;
   
    return directions[index];
  }



  getArrowPointingtoLoc = (lat, lon) => {



    let dir = this.getBearing(this.state.myLoc.lat, this.state.myLoc.lon, lat, lon) - this.state.heading
    return (dir < -157.5 ? IMGARROWDOWN :
              dir < -112.5 ? IMGARROWDOWNLEFT :
                dir < -67.5 ? IMGARROWLEFT :
                  dir < -22.5 ? IMGARROWUPLEFT :
                      dir < 22.5 ? IMGARROWUP :
                          dir < 67.5 ? IMGARROWUPRIGHT :
                              dir < 112.5 ? IMGARROWRIGHT :
                                  dir < 157.5 ? IMGARROWDOWNRIGHT :
                                      dir < 202.5 ? IMGARROWDOWN :
                                          dir < 247 ? IMGARROWDOWNLEFT :
                                              dir < 292 ? IMGARROWLEFT :
                                                  IMGARROWUPLEFT)
      
  }
  

  geoSuccess = (position) => {
    if (this._initTimeoutId != null) {
      clearTimeout(this._initTimeoutId);
      this._initTimeoutId = null;
    }
    if (this.state.active_page === HOME) {
      document.body.style = 'background: white';
      this.navbarClick(FEED)
    }
    this.setState({
      myLoc: { lat: position.coords.latitude, lon: position.coords.longitude },
    
    })

  }
  
  geoFailure = (err) => {
    if (this._initTimeoutId != null) {
      clearTimeout(this._initTimeoutId);
      this._initTimeoutId = null;
    }
    this.displayMsg("Enable Geolocation in Settings and retry", MSG_ERR)
    // Still leave the logo screen so the app loads (e.g. permission denied, timeout, unavailable)
    if (this.state.active_page === HOME) {
      document.body.style = 'background: white';
      this.setState({ active_page: FEED });
    }
  }


  deleteSurveyFromTasksByLocifValid = async (RespId, locIdx, svyIdx, newPage) => {
    let res = {}

    const params = {
      "survey": this.state.tasks_by_loc[locIdx].loc_surveys[svyIdx].survey,
      "response_loc": this.state.tasks_by_loc[locIdx].loc_surveys[svyIdx].svy_loc_scope_pk,
      "response_col": localStorage.getItem('colId')
    }

    try {
      res = await axios.get('/api/survey_response/', { params, headers: getAuthHeaders() })
    }
    catch(err) {
        console.error(err)
        this.displayMsg("Error Loading Response. Please try again", MSG_ERR)
    }

    if (res.data && res.data.at(-1)?.valid) {
      // Build a new tasks_by_loc without mutating existing state
      const newTasksByLoc = this.state.tasks_by_loc.map((loc, li) => {
        if (li !== locIdx) return loc;
        return {
          ...loc,
          loc_surveys: loc.loc_surveys.filter((_, si) => si !== svyIdx),
        };
      });
      this.setState({ tasks_by_loc: newTasksByLoc, active_page: newPage });
      this.displayMsg("Answers Loaded", MSG_OK)
    }
    else {
      // Stay on the survey page so the user can fix and retry or cancel
      this.displayMsg("ERROR:Respuestas incompletas. Revise y vuelva a enviar.", MSG_ERR)
    }
  }
  
  displayMsg = (msg_txt, msg_type) => {

    let msg_prefix = ""
    if (msg_type === MSG_ERR) msg_prefix = "ERROR:"
    if (msg_type === MSG_WARN) msg_prefix = "ALERT:"
    this.setState({ msg: { txt: msg_prefix + msg_txt, type: msg_type } })

  }
  
  
  organize_tasks_by_loc = (tasks) => {

    // organizes tasks per loc for rendering

    let tasks_by_loc = [];
    let prev_loc = -1;

    tasks.forEach(task => {
      if (task.loc_scope !== prev_loc) {
        tasks_by_loc.push({
          'loc_scope': task.loc_scope,
          'loc_name': task.loc_name,
          'loc_address': task.loc_address,
          'loc_distance': task.loc_distance,
          'loc_lat': task.loc_lat,
          'loc_lon': task.loc_lon,
          'loc_surveys': [],
        });
      }
      tasks_by_loc.at(-1).loc_surveys.push({
        'svy_loc_scope_pk': task.pk,
        'survey': task.survey,
        'survey_title': task.survey_title,
        'description': task.survey_description,
        'surveys_per_loc': task.survey_surveys_per_loc,
        'questions_per_survey': task.survey_questions_per_survey,
        'loc_requiered': task.survey_loc_requiered,
        'answer_at_location_enforced': task.survey_answer_at_location_enforced,
        'surveys_to_complete': task.surveys_to_complete,
        'surveys_completed': task.surveys_completed,
      });
      prev_loc = task.loc_scope;
    });

    return (tasks_by_loc)
  }


  update_distance = (locs) => {
    const start = {
      latitude: this.state.myLoc.lat,
      longitude: this.state.myLoc.lon,
    }
    return locs.map((l) => ({
      ...l,
      loc_distance: Math.round(haversine(start, { latitude: l.loc_lat, longitude: l.loc_lon }, { unit: 'meter' })),
    }))
  }
 

  getTasks = (locOrNoLoc, lat, lon, force = false) => {

    const params = {
      colId: localStorage.getItem('colId'),
      locOrNoLoc: locOrNoLoc,
      lat: lat,
      lon: lon
    }

    if (!params.colId) {
      this.displayMsg("Need to login first", MSG_ERR);
      return;
    }

    // Skip fetch if tasks are already loaded and caller didn't force a refresh
    if (!force && this.state.isLoaded && this.state.tasks_by_loc.length > 0) {
      return;
    }

    this.setState({ isLoaded: false })
    this.displayMsg("", MSG_OK)
    axios
      .get('/api/relevant_tasks/', { params, headers: getAuthHeaders() })
      .then(res => {
        const tasks = res.data;
        if (!tasks || tasks.length === 0) this.displayMsg("No Tasks near by", MSG_WARN)
        this.setState({
          tasks_by_loc: this.organize_tasks_by_loc(tasks),
          isLoaded: true,
          mapCenter: { lat: lat, lon: lon }
        })
      })
      .catch(() => { this.setState({ isLoaded: true }) })

  };


  openSurveyNoLoc = svyIndx => {

    this.setState({
      selected_loc: 0
    })
    this.openSurvey(svyIndx)
  
  }
  
  openSurvey = svyIndx => {

    this.setState({
      active_page: ANSWER_SVY,
      active_survey: svyIndx

    })

  }

 
  getSvyQuestions = () => {
    //gets tasks formn db and setState

    let survey = [];
  
    const params = {
      colId: localStorage.getItem('colId'),
      svyId: this.state.tasks_by_loc[this.state.selected_loc].loc_surveys[this.state.active_survey].survey
    }
    
    this.setState({ svy_questions: [], isLoaded: false })
    this.displayMsg("", MSG_OK)
    axios
      .get('/api/question_header/', { params, headers: getAuthHeaders() })
      .then(res => {
        survey = res.data;
        if (!survey) this.displayMsg("Failed loading survey", MSG_ERR)
        this.setState({ svy_questions: survey, isLoaded: true })
      })
      .catch(() => {})
          

  };

  withinDistance = (lat, lon) => {
    const start = {
      latitude: this.state.myLoc.lat,
      longitude: this.state.myLoc.lon
    }

    const end = {
      latitude: lat,
      longitude: lon
    }

 
    return haversine(start, end, {unit: 'meter'})< WITHIN_RAD
  }
  
  activateLoc = locIdx => {

    let activated = this.withinDistance(this.state.tasks_by_loc[locIdx].loc_lat, this.state.tasks_by_loc[locIdx].loc_lon)

    this.setState({
      selected_loc: locIdx,
      loc_is_activated: activated,
      active_page: ACTIVATE_LOC
    })

  };
    
  navbarClick = page => {


    const colId = localStorage.getItem('colId')
    const emailConfirmed = localStorage.getItem('emailConfirmed')


  
    if ([SURVEYS_BY_LOC, SURVEYS_BY_MAP, SURVEYS_NO_LOC, WALLET, FRIENDS, ANSWER_SVY, ACTIVATE_LOC, SETTINGS].includes(page)) {
      if (!colId) {
        this.setState({ active_page: FEED })
        this.displayMsg("Login requerido", MSG_ERR)
        return
      }
      //else {
      //  if (emailConfirmed === "false" || emailConfirmed === null) {
      //    this.setState({ active_page: LOGOUT })
      //    this.displayMsg("Porfavor confirmar email y repetir Login", MSG_ERR)
      //    return 
      //  }
      
      //}
      
    }
    

 
    const isTasksView = [SURVEYS_BY_LOC, SURVEYS_BY_MAP, SURVEYS_NO_LOC].includes(page);
    this.setState({
      active_page: page,
      ...(isTasksView && { lastTasksView: page }),
    });
    this.displayMsg("", MSG_OK);
  };
  
  render_active_page = () => {
  
    let msgclassName = 'container-fluid status-banner ' + this.state.msg.type + ' w-100'
    return (
      <Fragment>
        {this.state.msg.txt !== "" ? (
          <div className={msgclassName}>
            <small>{this.state.msg.txt}</small>
          </div>
        ) : null}
        {this.render_active_page_body()}
      </Fragment>

    )

  }
  
  
  render_active_page_body = () => {

    //this.getLocation() Nope -> se clava

    switch (this.state.active_page) {


      case CLIENT_SURVEYS: {
        return <p>***** CLIENT_SURVEYS *****</p>
      }
  
      case SURVEYS_BY_LOC: {
        return <Tasks
          tasks_by_loc={this.state.tasks_by_loc}
          selected_loc={this.state.selected_loc}
          isLoaded={this.state.isLoaded}
          myLoc={this.state.myLoc}
          onActivateLoc={this.activateLoc}
          getTasks={this.getTasks}
          toogleClick={this.navbarClick}
          getLocation={this.getLocation}
          displayMsg={this.displayMsg}
          update_distance={this.update_distance}
          GetHeadingpoint={this.GetHeadingpoint}
          getArrowPointingtoLoc={this.getArrowPointingtoLoc}
          //getBearing = {this.getBearing}
        />
      }
        
      case SURVEYS_BY_MAP: {
        return <TasksMap
          tasks_by_loc={this.state.tasks_by_loc}
          selected_loc={this.state.selected_loc}
          isLoaded={this.state.isLoaded}
          onActivateLoc={this.activateLoc}
          getTasks={this.getTasks}
          toogleClick={this.navbarClick}
          onOpen={this.openSurvey}
          myLoc={this.state.myLoc}
          mapCenter={this.state.mapCenter}
          update_distance={this.update_distance}
          GetHeadingpoint={this.GetHeadingpoint}
          getArrowPointingtoLoc={this.getArrowPointingtoLoc}
          //heading={this.this.state.heading}
        />
      }
        
      case SURVEYS_NO_LOC: {
        return <TasksNoLoc
          tasks_by_loc={this.state.tasks_by_loc}
          selected_loc={this.state.selected_loc}
          isLoaded={this.state.isLoaded}
          toogleClick={this.navbarClick}
          onOpen={this.openSurveyNoLoc}
        />
      }
        
      case ANSWER_SVY: {
        return <AnswerSurvey
          svy_questions={this.state.svy_questions}
          getSvyQuestions={this.getSvyQuestions}
          tasks_by_loc={this.state.tasks_by_loc}
          selected_loc={this.state.selected_loc}
          active_survey={this.state.active_survey}
          onCancel={this.navbarClick}
          deleteSurveyFromTasksByLocifValid={this.deleteSurveyFromTasksByLocifValid}
          displayMsg={this.displayMsg}
          myLoc={this.state.myLoc}
          GetHeadingpoint={this.GetHeadingpoint}
          getArrowPointingtoLoc={this.getArrowPointingtoLoc}
          
        />

      }
        
      case FRIENDS:
        return <Friends
                displayMsg={this.displayMsg}
        />
      
      case WALLET:
        return <Transactions
          displayMsg={this.displayMsg}
        />

      case SETTINGS:
        return <CollaboratorSettings
          displayMsg={this.displayMsg}
          onCancel={() => this.navbarClick(FEED)}
        />
      
      case LOGIN:
        return <Login />
      
      case REGISTER:
        return <Signup />
      
      case LOGOUT:
        return <Logout />
             
      case ACTIVATE_LOC:
        return <ActivateLoc
          tasks_by_loc={this.state.tasks_by_loc}
          selected_loc={this.state.selected_loc}
          myLoc={this.state.myLoc}
          loc_is_activated={this.state.loc_is_activated}
          onOpen={this.openSurvey}
          onActivateLoc={this.activateLoc}
          GetHeadingpoint={this.GetHeadingpoint}
          getArrowPointingtoLoc={this.getArrowPointingtoLoc}
          displayMsg={this.displayMsg}
          onBack={() => this.navbarClick(this.state.lastTasksView)}
        />
          
      case FEED:
        return <NewsFeed />
    }
  }
  
  componentDidMount() {
    this.GetHeadingpoint()
    // If location never resolves (denied, timeout, unsupported), leave logo after 5s
    this._initTimeoutId = setTimeout(() => {
      if (this.state.active_page === HOME) {
        document.body.style = 'background: white';
        this.setState({ active_page: FEED });
        this.displayMsg('Enable Geolocation in Settings and retry', MSG_ERR);
      }
    }, 5000);
    this.getLocation()
  }



  componentWillUnmount() {
    if (this._initTimeoutId != null) clearTimeout(this._initTimeoutId);
    window.removeEventListener('deviceorientation', this.deviceOrientationListener);
    if (this.watchLocId != null) {
      navigator.geolocation.clearWatch(this.watchLocId);
    }
  }

  render() {
    if (this.state.active_page === HOME) {
      return (
              <Router basename="/app">
                <Init />
              </Router>
    )
    } else {
      
      return (
        
      <Fragment>
        <Router basename="/app">
          <NavBarBrand navbarClick={this.navbarClick} />
          <main className='container'>
            {this.render_active_page()}
          </main>

          <NavBarMenu
            active_page={this.state.active_page}
            lastTasksView={this.state.lastTasksView}
            navbarClick={this.navbarClick}
            />
            


  
        </Router>
      </Fragment >
      )}
  }
}

export default App;
